import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const EllipsisTypography = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
